"use client";

import textconfig from "@/textconfig";
import clsx from "clsx";

import { rpc } from "#rpc";
import Skeleton from "@/components/atoms/Skeleton";
import useSelection from "@/lib/hooks/useSelection";
import { RecipeProductCard } from "@/types/product";
import type { DeepPartial } from "@apollo/client/utilities";
import { useQuery } from "@tanstack/react-query";
import { getItemsWithTypeRecipe } from "../actions";
import { RecipeCard } from "../RecipeCard";
import styles from "../recipes.module.css";

export type Recipe = DeepPartial<RecipeProductCard> & {
  download: {
    uri: string;
    lastModified?: string;
  };
};

const RecipesUI = () => {
  const customerToken = useSelection().data?.token;

  const {
    data: orders,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["getOrders", customerToken],
    queryFn: async () => {
      if (customerToken) return await rpc.users.orders(customerToken);
    },
    enabled: !!customerToken,
  });

  const { data: itemsWithTypeRecipe } = useQuery({
    queryKey: ["getItemsWithTypeRecipe"],
    queryFn: async () => {
      if (orders) {
        return getItemsWithTypeRecipe(orders);
      }
      return [];
    },
    enabled: !!orders,
  });

  const translations = textconfig.account.recipes;
  const hasNoRecipe = !itemsWithTypeRecipe;

  const Header = () =>
    hasNoRecipe ? null : (
      <div className={clsx(styles.grid, styles.grid__header)}>
        {translations.menus.map((menu, index) => (
          <h2 className={styles.tab__heading} key={"menu--" + index}>
            {menu}
          </h2>
        ))}
      </div>
    );

  const NoRecipesMessage = () =>
    hasNoRecipe ? (
      <div className={styles["no-orders"]}>
        <p>{translations.noRecipesMessage}</p>
      </div>
    ) : null;

  const Recipes = () =>
    itemsWithTypeRecipe?.map((recipe, index) =>
      isLoading ? (
        <div key={index}>
          <Skeleton height={"50px"} />
          <Skeleton height={"50px"} />
          <Skeleton height={"50px"} />
        </div>
      ) : hasNoRecipe ? (
        <NoRecipesMessage />
      ) : (
        <RecipeCard key={index} recipeCard={recipe} index={index} />
      )
    );

  return (
    <>
      <Header />
      <Recipes />
    </>
  );
};

const ClientUI = () => {
  return <RecipesUI />;
};

export default ClientUI;
